export default "__VITE_ASSET__DRg1GOEy__"